export { DashboardPage } from './dashboard/page';
export { ListProjectPage } from './list-project/page';
export { NotesPage } from './notes/page';
export { ProjectDetailPage } from './project-detail/page';
export { SchedulePage } from './schedule/page';
export { TaskPage } from './task/page';
export { FormTaskPage } from './form_task/page';
export { FormSchedulePage } from './form_schedule/page';
export { DetailSchedulePage } from './detail_schedule/page';
export { DetailTaskPage } from './detail_task/page';
export { FormNotePage } from './form_note/page';
export { FormProjectPage } from './form_project/page';
export { ProfilePage } from './profile/page';
export { ActivityPage } from './activity/page';
export { LoginPage } from './login/page';
export { DetailImagePage } from './detail_image/page';
export { AboutPage } from './about/page';
export { ListNotificationPage } from './list_notification/page';
export { ListSubscribersPage } from './list_subscribers/page';
export { SelectPage } from './select/page';
export { DetailUsagePage } from './detail_usage/page';
export { DetailBudgetPage } from './detail_budget/page';
export { FormInvPage } from './form_inv/page';
export { InvoicePage } from './invoice/page';
export { DetailInvPage } from './detail_inv/page';
export { ListAR } from './list_ar/page';



// WEBPACK FOOTER //
// ./src/pages/project_mobile/index.ts